import { render, staticRenderFns } from "./EventsBox.vue?vue&type=template&id=3982f450&"
import script from "./EventsBox.vue?vue&type=script&lang=js&"
export * from "./EventsBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports